// extracted by mini-css-extract-plugin
export default {"popup":"infobox_popup__dCDwQ","popup__close":"infobox_popup__close__Xe4+i","popup__error":"infobox_popup__error__Gl+lT","popup__error__close":"infobox_popup__error__close__b-EJw"};